<template>
  <div>
    <div class="header">
      <div class="top">
        click
        <a href="javascript:;" @click="delivery">here</a> to order online
      </div>
      <div class="container">
        <div class="flexbox">
          <div class="logo">
            <img src="../../../assets/logo.png" alt />
          </div>
          <div class="nav">
            <ul>
              <li class="active">
                <a href="#">HOME</a>
              </li>
              <li>
                <a href="#about">ABOUT US</a>
              </li>
              <li>
                <a href="#menu">MENU</a>
              </li>
              <li>
                <a href="#gallery">GALLERY</a>
              </li>
              <li>
                <a href="#contact">CONTACT</a>
              </li>
              <li>
                <a href="javascript:;" @click="delivery">ONLINE ORDER</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="m-header" >
      <div class="logo">
        <img src="../../../assets/logo.png" alt />
      </div>
      <span class="iconfont icon-caidan" @click="mshow"></span>

      <div class="m-nav" :class="{show:navIsShow}" @touchmove.prevent>
        <ul>
          <li class="active" @click="mshow">
            <a href="#">HOME</a>
          </li>
          <li @click="mshow">
            <a href="#about">ABOUT US</a>
          </li>
          <li @click="mshow">
            <a href="#menu">MENU</a>
          </li>
          <li @click="mshow">
            <a href="#gallery">GALLERY</a>
          </li>
          <li @click="mshow">
            <a href="#contact">CONTACT</a>
          </li>
          <li @click="mshow">
            <a href="javascript:;" @click="delivery">ONLINE ORDER</a>
          </li>
        </ul>

        <div class="nav-logo">
          <img src="../../../assets/logo.png" alt />
        </div>
      </div>
      <div class="mask" :class="{showMask:navIsShow}" @click="mshow"  @touchmove.prevent></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header2",
  props: {},
  data() {
    return {
      navIsShow: false
    };
  },
  components: {},
  methods: {
    delivery() {
      window.open("https://us.orderspoon.com/peking-chinese-restaurant")
    },
    mshow() {
      this.navIsShow = !this.navIsShow;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;

  @media (max-width: 799px) {
    display: none;
  }
  .container {
    padding: 1.06061rem 0;
  }
  .top {
    background: #f4b336;
    color: #fff;
    text-align: center;
    a {
      text-decoration: underline;
    }
  }
  .flexbox {
    display: flex;
    flex-flow: row nowrap;
    .logo {
      flex: 15%;
      img {
        width: 80%;
        height: 80%;
      }
    }
    .nav {
      flex: 85%;
      padding: 0.606061rem;
    }
  }
  ul {
    display: flex;
    flex-flow: row nowrap;
    vertical-align: middle;
    justify-content: space-between;
    li {
      color: #fff;
      font-family: "Microsoft YaHei";
      font-size: 0.727273rem;
      white-space: nowrap;
      list-style: none;
      text-transform: uppercase;
      width: 4.69697rem;
      img {
        width: 100%;
      }
      a {
        text-align: center;
        border-radius: 1.060606rem;
        display: block;
        width: 100%;
        height: 100%;
      }
      &:not(.logo) {
        width: fit-content;
      }
      &:not(.logo):hover,
      &.active {
        a {
          color: #ff8c00;
          position: relative;
          &::after {
            content: "";
            display: block;
            width: 50%;
            height: 2px;
            background: #ff8c00;
            margin: 0.606061rem auto;
          }
        }
      }
    }
  }
}

.m-header {
  display: none;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  @media (max-width: 799px) {
    display: block;
  }
  padding: 0.806061rem;
  .logo {
    width: 20vw;
    float: left;
    img {
      width: 100%;
    }
  }
  .icon-caidan {
    font-size: 10vw;
    color: #f4b336;
    float: right;
  }
  .m-nav {
    width: 60vw;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    background: #fff;
    transform: translateX(60vw);
    transition: all 0.4s ease-in-out;
    z-index: 9999;
    visibility: hidden;
    .nav-logo {
      width: 100%;
      margin: 1.515152rem auto;
      img {
        width: 100%;
      }
    }

    li {
      margin: 1.515152rem auto;
      a {
        display: block;
        text-align: center;
        font-family: "Microsoft YaHei";
        color: #f4b336;
        font-size: 1.515152rem;
        border-bottom: 2px solid #f4b336;
        width: fit-content;
        margin: 0 auto;
      }
    }
  }
  .show {
    transform: translateX(0);
    visibility: visible;
  }
  .mask {
    display: none;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    z-index: 9998;
  }
  .showMask {
    display: block;
  }
}
</style>
